import { IOperatorTailState, actionTypes } from 'src/ducks/operator-tail.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getOperatorTailStatus = (
  state: IOperatorTailState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
